<template>
    <v-card shaped class="pa-4">
        <v-row>
            <v-col cols="12">
                <v-toolbar flat color="#1d2735" dark style="border-radius: 5px">
                    <v-icon class="white--text" style="font-size: 45px"
                        >mdi-account-supervisor-circle</v-icon
                    >
                    <pre><v-toolbar-title><h2>Crear obra</h2></v-toolbar-title></pre>
                </v-toolbar>
                <v-form class="mt-3">
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="plan.id_estado"
                                :items="estados"
                                item-text="nombre"
                                item-value="id"
                                label="Estados"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="plan.id_equipo"
                                :items="equipos"
                                item-text="nombre"
                                item-value="id"
                                label="Equipo"
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="2">
                            <date-select
                                v-model="plan.fecha"
                                label="Fecha de inicio"
                            >
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="2">
                            <date-select
                                v-model="plan.fecha_fin"
                                label="Fecha de fin"
                            >
                            </date-select>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field
                                v-model="plan.horario"
                                label="Horario"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="plan.observacion"
                                label="Observaciones"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-btn
                                color="red"
                                class="white--text"
                                @click="
                                    plan = {
                                        id_orden: value,
                                    }
                                "
                            >
                                Limpiar
                            </v-btn>
                            <v-btn
                                color="primary"
                                class="white--text"
                                @click="createorden"
                            >
                                {{ plan.id != null ? "Actualizar" : "Añadir" }}
                            </v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-data-table :items="planes" :headers="headers">
                                <template v-slot:item.fecha="{ item }">
                                    <span>{{ item.fecha | format_date }}</span>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                        @click.stop="edit(item)"
                                        small
                                        class="mr-2"
                                        color="#1d2735"
                                        style="font-size: 25px"
                                        title="Ver"
                                        >mdi-pencil</v-icon
                                    >

                                    <v-icon
                                        @click="openModal(item)"
                                        small
                                        class="mr-2"
                                        color="red"
                                        style="font-size: 25px"
                                        title="BORRAR"
                                        >mdi-trash-can</v-icon
                                    >
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>

                    <!--v-row>
                        <v-col cols="12">
                            <router-link to="lista-orden">
                                <v-btn color="red" class="white--text" s>
                                    Cancelar
                                </v-btn>
                            </router-link>
                            <v-btn
                                v-if="!plan.id"
                                :disabled="isloading"
                                color="success"
                                class="white--text"
  
                                >Guardar</v-btn
                            >
                            <v-btn
                                @click="createorden"
                                v-if="plan.id"
                                :disabled="isloading"
                                color="success"
                                class="white--text"
                                >Actualizar</v-btn
                            >
                            <v-btn
                                @click="deleteorden"
                                v-if="plan.id"
                                :disabled="isloading"
                                color="red"
                                class="white--text"
                                >Eliminar</v-btn
                            >
                        </v-col>
                    </!--v-row-->
                </v-form>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { debounce } from "../../../helpers";
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
export default {
    components: {
        ordenesSelect,
    },
    props: ["value"],
    data() {
        return {
            selectedItem: null,
            dialog: false,
            headers: [
                {
                    text: "Obra",
                    value: "orden_trabajo.nro_orden",
                    sortable: false,
                },
                { text: "Equipo", value: "equipo.nombre", sortable: false },

                {
                    text: "Observaciones",
                    value: "observacion",
                    sortable: false,
                },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            productos: [],
            acciones: [],
            controles: [],
            equipos: [],
            ordenes: [],
            orden: {},
            plan: {},
            planes: [],
            //Cruds de Selects dinamicos
            accion: {
                nombre: "",
            },
            control: {
                nombre: "",
            },
            estados: [],
        };
    },
    watch: {
        value(val) {
            this.getPlanes();
        },
    },
    created() {
        this.getEstados();

        this.getequipos();

        if (this.value != null) {
            this.getPlanes();
        }
    },
    methods: {
        edit(item) {
            this.plan = JSON.parse(JSON.stringify(item));
        },
        openModal(item) {
            this.selectedItem = this.planes.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/cancel-plan-orden", {
                    id: this.ordenes[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Plan eliminado con éxito");
                        this.dialog = false;
                        this.getPlanes();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el plan");
                    }
                );
        },

        getequipos() {
            axios.get(`api/get-equipos`).then(
                (res) => {
                    this.equipos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los equipos");
                }
            );
        },
        getEstados() {
            axios.get(`api/get-estados-plan-orden`).then(
                (res) => {
                    this.estados = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando el estado");
                }
            );
        },
        //funciones del Crud de Acciones

        getPlanes() {
            this.plan = {};

            this.plan.id_orden = this.value;

            axios.get(`api/get-planes-orden?id_orden=${this.value}`).then(
                (res) => {
                    this.planes = res.data;
                },
                (res) => {}
            );
        },
        deleteorden(id) {
            axios.post("api/delete-orden", { id: id }).then(
                (res) => {
                    this.$router.push("lista-plan-orden");
                },
                (res) => {}
            );
        },
        createorden() {
            this.plan.id_orden = this.value;
            axios
                .post("api/save-plan-orden", this.plan)
                .then((res) => {
                    //this.$router.push("lista-plan-orden");
                    this.getPlanes();
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error(error.response.data.message);
                    }
                });
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        clientes() {
            /////console.log("siva");
            let clientes_temp = this.$store.getters.getclientes;

            return clientes_temp;
        },
        rol: function () {
            return localStorage.getItem("role");
        },
    },
};
</script>
